import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { AveriasService } from '../servicios/averias.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { AreaComponente } from "../entidades/entidades.component";
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { DatePipe } from '@angular/common';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { NbCheckboxModule } from '@nebular/theme';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-area-componente',
    templateUrl: './area-componente.component.html',
    styleUrls: ['./area-componente.component.css'],
    standalone: true,
    imports: [FormsModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, 
      MatCardModule, MatFormFieldModule, MatInputModule, SpinnerComponent, 
      AngularSlickgridModule, NbTabsetModule, AgGridAngular,
    NbCheckboxModule],
    providers: [DatePipe],
})
export class AreaComponenteComponent implements OnInit {
  eliminar = false
  durationInSeconds = 3;
  firstForm: UntypedFormGroup;
  areaComponente: SelectItem[];
  areaComponenteOK = false;
  IdAreaComponente: number;
  showAreaComponente = false
  areaComponenteProcesadaAlta;
  descripcionAreaComponente;
  descripcionAreaEditarComponente;
  descripcionBreveComponente;
  descripcionBreveEditarComponente;
  codigoExternoComponente;
  codigoExternoEditarComponente;
  areaComponenteCompleta;
  idCliente: number;
  idComponente;
  componenteOK = false;
  componente: SelectItem[];
  componenteCompleto;
  showComponente;
  area: SelectItem[];
  areaOK = false;
  IdArea: number;
  showArea;
  areaProcesada;
  areaProcesadaAlta;
  areaCompleta;
  datasetAreaComponente: any[] = [];
  datasetAreaComponenteModificar: any[] = [];
  angularGridAreaComponente: AngularGridInstance;
  datasetAreaComponenteConsulta: any[] = [];
  angularGridAreaComponenteConsulta: AngularGridInstance;
  angularGridAreaComponenteModificar: AngularGridInstance;
  showSpinner = false;
  showSpinnerConsulta = false;
  //columnDefinitionsComponente: ColDef[];//Column[];
  columnDefinitionsAreaComponente: ColDef[];//Column[];
  gridOptionsAreaComponente: GridOption;
  columnDefinitionsAreaComponenteConsulta: ColDef[];//Column[];
  columnDefinitionsAreaComponenteModificar: ColDef[];//Column[];
  gridOptionsAreaComponenteConsulta: GridOption;
  gridOptionsAreaComponenteModificar: GridOption;
  gridObjAreaComponente: any;
  showGrilla = false;
  showGrillaConsulta = false;
  showGrillaModificar = false;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  averiasAreaComponente = [];
  componenteCompletoModificar;
  areaComponenteSeleccionada;
  eliminarSeleccionado;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;

  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, private dateFormatter: DatePipe, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    // this.consultarAreaComponente();
    this.consultarArea();
    this.consultarComponente();
    this.svcAnalytics.setAnalyticsPageView();
  }
  ngAfterViewInit():void {

  }

  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarAreaComponente();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarAreaComponenteConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarAreaComponenteModificar();
    }
  }

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarComponente() {
    this.AveriasService.getComponente(this.idCliente).subscribe(
      data => {
        this.componenteCompleto = data;
        this.componente = this.insertarComponente(data);
        this.showComponente = true;
      });
  }
  insertarComponente(armarComponente) {
    let averiasComponente: Array<any> = [];
    armarComponente.content.forEach(element => {
      averiasComponente.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasComponente;
  };
  capturarComponente(event) {
    this.idComponente = event;
    this.componenteOK = true;
  }
  consultarArea() {
    this.AveriasService.getArea(this.idCliente).subscribe(
      data => {
        this.areaCompleta = data;
        this.area = this.insertarArea(data);
        this.showArea = true;
      });
  }
  insertarArea(armarArea) {
    let averiasArea: Array<any> = [];
    armarArea.content.forEach(element => {
      averiasArea.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasArea;
  };
  capturarArea(event) {
    this.IdArea = event;
    this.areaOK = true;
  }
  consultarAreaComponente() {
    this.showSpinner = true;
    this.showGrilla = false;
    this.AveriasService.getAreaComponente(this.idCliente).subscribe(
      data => {
        this.areaComponenteCompleta = data;
        this.areaComponente = this.insertarAreaComponente(data);
        this.traerDatosAreaComponente();
        this.fillGrillaAreaComponente();
      });
  }
  consultarAreaComponenteConsulta() {
    this.showSpinnerConsulta = true;
    this.showGrillaConsulta = false;
    this.AveriasService.getAreaComponente(this.idCliente).subscribe(
      data => {
        this.areaComponenteCompleta = data;
        this.traerDatosAreaComponenteConsulta();
        this.fillGrillaAreaComponenteConsulta();
      });
  }
  consultarAreaComponenteModificar() {
    this.showSpinnerModificar = true;
    this.showGrillaModificar = false;
    this.AveriasService.getAreaComponente(this.idCliente).subscribe(
      data => {
        this.areaComponenteCompleta = data;
        this.areaComponente = this.insertarAreaComponente(data);
        this.traerDatosAreaComponenteModificar();
        this.fillGrillaAreaComponenteModificar();
      });
  }

  // getAreaComponenteModificar() {
  //   this.AveriasService.getAreaComponente(this.idCliente).subscribe(
  //     data => {
  //       this.areaComponenteCompleta = data;
  //       this.areaComponente = this.insertarAreaComponente(data);
  //     });
  // }

  insertarAreaComponente(armarAreaComponente) {
    armarAreaComponente.content.forEach(element => {
      this.averiasAreaComponente.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return this.averiasAreaComponente;
  };
  capturarAreaComponente(event) {
    this.IdAreaComponente = event;
    this.areaComponenteOK = true;
  }
  altaAreaComponente() {
    let areaComponente: AreaComponente;

    if (this.descripcionAreaComponente == null || this.descripcionAreaComponente == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreveComponente == null || this.descripcionBreveComponente == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExternoComponente == null || this.codigoExternoComponente == "") {
      this.openSnackBar("Debe completar el Código Externo ❌");
    } else {
      areaComponente = {
        descripcion: this.descripcionAreaComponente,
        descripcionAbreviada: this.descripcionBreveComponente,
        codigoExterno: this.codigoExternoComponente,
        idArea: this.areaProcesadaAlta,
        idComponente: this.areaComponenteProcesadaAlta,
        idCliente: this.idCliente,
      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postAreaComponente(areaComponente).subscribe(data => {
        if (data["status"] == 201) {
          this.openSnackBar('Los cambios se han guardado correctamente');
        } else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos');
        }
        this.descripcionAreaComponente = '';
        this.descripcionBreveComponente = '';
        this.codigoExternoComponente = '';
        this.consultarAreaComponente();
        this.componenteCompleto = [];
        this.areaProcesadaAlta = [];
        this.showSpinnerGuardar = false;
      })
    }
  }
  modificarAreaComponente() {
    if (this.eliminar) {
      this.AveriasService.deleteAreaComponente(this.areaComponenteSeleccionada).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionAreaEditarComponente = '';
          this.descripcionBreveEditarComponente = '';
          this.codigoExternoEditarComponente = '';
          this.areaComponenteSeleccionada = '';
          this.componenteCompletoModificar = [];
          this.areaProcesada = [];
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminar = false;
        this.eliminarSeleccionado = false;
      })
    } else {
      if (this.descripcionAreaEditarComponente == null || this.descripcionAreaEditarComponente == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditarComponente == null || this.descripcionBreveEditarComponente == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditarComponente == null || this.codigoExternoEditarComponente == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        let areaComponente = {
          descripcion: this.descripcionAreaEditarComponente,
          descripcionAbreviada: this.descripcionBreveEditarComponente,
          codigoExterno: this.codigoExternoEditarComponente,
          idCliente: this.idCliente,
          idArea: this.areaProcesada,
          idComponente: this.componenteCompletoModificar
        }
        this.AveriasService.putAreaComponente(this.areaComponenteSeleccionada, areaComponente).subscribe(data => {
          if (data["status"] == 200) {
            this.openSnackBar('Los cambios se han guardado correctamente');
          } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
          this.showSpinnerModificar = false;
          this.eliminar = false;
          this.eliminarSeleccionado = false;
        })
        this.descripcionAreaEditarComponente = '';
        this.descripcionBreveEditarComponente = '';
        this.codigoExternoEditarComponente = '';
        this.areaComponenteSeleccionada = '';
        this.componenteCompletoModificar = [];
        this.areaProcesada = [];
      }
    }
  }
  obtenerDescripcionDropdown(IdAreaComponente: number) {
    let resp = this.areaComponenteCompleta.content.find(n => n['id'] == IdAreaComponente);
    this.descripcionBreveEditarComponente = resp['descripcionAbreviada'];
    this.descripcionAreaEditarComponente = resp['descripcion'];
    this.codigoExternoEditarComponente = resp['codigoExterno'];
    this.areaProcesada = resp['idArea'];
    this.componenteCompletoModificar = resp['idComponente'];
    this.eliminarSeleccionado = false;
  }
  //Grilla AreaComponente
  traerDatosAreaComponente() {
    let DatosAreaComponente = this.areaComponenteCompleta['content'];

    let mockDataset: any = [];
    for (let i = 0; i < DatosAreaComponente.length; i++) {
      mockDataset.push({
        id: DatosAreaComponente[i]["id"],
        Descripcion: DatosAreaComponente[i]["descripcion"],
        DescripcionAbreviada: DatosAreaComponente[i]["descripcionAbreviada"],
        Codigo: DatosAreaComponente[i]["codigoExterno"],
      });
    }
    this.datasetAreaComponente = mockDataset;
    this.showSpinner = false;
    this.showGrilla = true;
  }

  traerDatosAreaComponenteConsulta() {
    let DatosAreaComponente = this.areaComponenteCompleta['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosAreaComponente.length; i++) {
      mockDataset.push({
        id: DatosAreaComponente[i]["id"],
        Descripcion: DatosAreaComponente[i]["descripcion"],
        DescripcionAbreviada: DatosAreaComponente[i]["descripcionAbreviada"],
        Codigo: DatosAreaComponente[i]["codigoExterno"],
      });
    }
    this.datasetAreaComponenteConsulta = mockDataset;
    this.showSpinnerConsulta = false;
    this.showGrillaConsulta = true;
  }

  traerDatosAreaComponenteModificar() {
    let DatosAreaComponente = this.areaComponenteCompleta['content'];

    let mockDataset: any = [];
    for (let i = 0; i < DatosAreaComponente.length; i++) {
      mockDataset.push({
        id: DatosAreaComponente[i]["id"],
        Descripcion: DatosAreaComponente[i]["descripcion"],
        DescripcionAbreviada: DatosAreaComponente[i]["descripcionAbreviada"],
        Codigo: DatosAreaComponente[i]["codigoExterno"],
      });
    }
    this.datasetAreaComponenteModificar = mockDataset;
    this.showSpinnerModificar = false;
    this.showGrillaModificar = true;
  }
  fillGrillaAreaComponente() {
    this.columnDefinitionsAreaComponente = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100 },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100, },
      { //id: 'Codigo', 
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60 },
    ];
    this.gridOptionsAreaComponente = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  fillGrillaAreaComponenteConsulta() {
    this.columnDefinitionsAreaComponenteConsulta = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100 },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100, },
      { //id: 'Codigo', 
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60 },
    ];
    this.gridOptionsAreaComponenteConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }

  fillGrillaAreaComponenteModificar() {
    this.columnDefinitionsAreaComponenteModificar = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100 },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100, },
      { //id: 'Codigo', 
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60 },
    ];
    this.gridOptionsAreaComponenteModificar = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  angularGridReadyAreaComponente(angularGrid: AngularGridInstance) {
    this.angularGridAreaComponente = angularGrid;
    this.angularGridAreaComponente.resizerService.pauseResizer(false)
  }
  angularGridReadyAreaComponenteConsulta(angularGrid: AngularGridInstance) {
    this.angularGridAreaComponenteConsulta = angularGrid;
    this.angularGridAreaComponenteConsulta.resizerService.pauseResizer(false)
  }
  angularGridReadyAreaComponenteModificar(angularGrid: AngularGridInstance) {
    this.angularGridAreaComponenteModificar = angularGrid;
    this.angularGridAreaComponenteModificar.resizerService.pauseResizer(false)
  }

  // exportToExcelAreaComponente() {
  //   //this.angularGridAreaComponenteConsulta.excelExportService
  //   (this.angularGridAreaComponenteConsulta as any).excelExportService.exportToExcel({
  //     filename: 'Área Componente_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
  //     format: FileType.xlsx
  //   });
  // }


      exportToExcelAreaComponente(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'AreaComponente': worksheet },
          SheetNames: ['AreaComponente']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Área Componente_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }
  
}
